/**
 * Narang Giveaway System - Frontend Logic
 * Version: 1.0
 * Handles: Registration, Validation, AJAX, Modals
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  
  const CONFIG = {
    mechanicWebhookUrl: 'https://webhooks.mechanic.dev/ecd8d743-60fa-4a8a-a342-3ee1ebc29fb0', // Replace with your Mechanic webhook
    minQuantity: 1,
    maxQuantity: 10,
    debounceDelay: 300
  };

  // ============================================
  // STATE MANAGEMENT
  // ============================================
  
  let STATE = {
    currentGiveaway: null,
    customerData: null,
    isProcessing: false
  };

  // ============================================
  // INITIALIZATION
  // ============================================
  
  function init() {
    loadCustomerData();
    attachEventListeners();
    initializeDatePicker();
    console.log('✅ Giveaway system initialized');
  }

  // Load customer data from hidden JSON
  function loadCustomerData() {
    const dataElement = document.getElementById('giveaway-data');
    if (dataElement) {
      try {
        STATE.customerData = JSON.parse(dataElement.textContent);
        console.log('Customer data loaded:', STATE.customerData);
      } catch (error) {
        console.error('Error parsing customer data:', error);
      }
    }
  }

  // ============================================
  // EVENT LISTENERS
  // ============================================
  
  function attachEventListeners() {
    // Register buttons
    document.querySelectorAll('.register-btn').forEach(btn => {
      btn.addEventListener('click', handleRegisterClick);
    });

    // Modal close buttons
    document.querySelectorAll('.modal-close').forEach(btn => {
      btn.addEventListener('click', closeAllModals);
    });

    // Modal overlays
    document.querySelectorAll('.modal-overlay').forEach(overlay => {
      overlay.addEventListener('click', closeAllModals);
    });

    // Quantity controls
const qtyDecrease = document.querySelector('.qty-decrease');
const qtyIncrease = document.querySelector('.qty-increase');
const qtyInput = document.getElementById('entry-quantity');

// Remove any existing listeners first (if this code runs multiple times)
if (qtyDecrease) {
  const newDecrease = qtyDecrease.cloneNode(true);
  qtyDecrease.parentNode.replaceChild(newDecrease, qtyDecrease);
  newDecrease.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    adjustQuantity(-1);
  });
}

if (qtyIncrease) {
  const newIncrease = qtyIncrease.cloneNode(true);
  qtyIncrease.parentNode.replaceChild(newIncrease, qtyIncrease);
  newIncrease.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    adjustQuantity(1);
  });
}

if (qtyInput) {
  qtyInput.removeEventListener('input', handleQuantityInput);
  qtyInput.addEventListener('input', handleQuantityInput);
}

    // Redeem button
    const redeemBtn = document.getElementById('redeem-btn');
    if (redeemBtn) redeemBtn.addEventListener('click', handleRedeemClick);

    // Confirmation buttons
    const confirmYes = document.getElementById('confirm-yes-btn');
    const confirmNo = document.getElementById('confirm-no-btn');
    if (confirmYes) confirmYes.addEventListener('click', handleConfirmYes);
    if (confirmNo) confirmNo.addEventListener('click', closeAllModals);

    // Success/Error close buttons
    const successClose = document.getElementById('success-close-btn');
    const errorClose = document.getElementById('error-close-btn');
    if (successClose) successClose.addEventListener('click', handleSuccessClose);
    if (errorClose) errorClose.addEventListener('click', closeAllModals);

    // ESC key to close modals
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllModals();
    });
  }

  // ============================================
  // REGISTER BUTTON HANDLER
  // ============================================
  
  function handleRegisterClick(e) {
    const btn = e.currentTarget;
    
    // Extract data from button attributes
    STATE.currentGiveaway = {
      productId: btn.dataset.productId,
      giveawayCode: btn.dataset.giveawayCode,
      prizeTitle: btn.dataset.prizeTitle,
      prizeImage: btn.dataset.prizeImage,
      pointsPerEntry: parseInt(btn.dataset.pointsPerEntry),
      pointType: btn.dataset.pointType,
      totalSlots: parseInt(btn.dataset.totalSlots),
      bookedSlots: parseInt(btn.dataset.bookedSlots),
      remainingSlots: parseInt(btn.dataset.remainingSlots)
    };

    console.log('Opening quickview for:', STATE.currentGiveaway);
    openQuickViewModal();
  }

  // ============================================
  // QUICK VIEW MODAL
  // ============================================
  
  function openQuickViewModal() {
    const modal = document.getElementById('giveaway-quickview-modal');
    const giveaway = STATE.currentGiveaway;
    const customer = STATE.customerData;

    // Populate modal content
    document.getElementById('modal-giveaway-code').textContent = giveaway.giveawayCode;
    document.getElementById('modal-prize-title').textContent = giveaway.prizeTitle;
    // Populate modal media (video or image)
const modalMediaContainer = document.getElementById('modal-media-container');
if (giveaway.mediaHtml) {
  modalMediaContainer.innerHTML = giveaway.mediaHtml;
} else {
  modalMediaContainer.innerHTML = `<img src="${giveaway.prizeImage}&width=800" alt="${giveaway.prizeTitle}" class="modal-image-element" loading="eager">`;
}

    // Get customer's available points for this type
    const availablePoints = giveaway.pointType === 'gold' 
      ? customer.gold_available 
      : customer.silver_available;

    const pointLabel = giveaway.pointType === 'gold' ? 'G-Points' : 'S-Points';
    const pointIcon = giveaway.pointType === 'gold' ? '' : '';

    document.getElementById('modal-available-points').textContent = `${pointIcon} ${availablePoints} ${pointLabel}`;
    document.getElementById('modal-points-per-entry').textContent = `${pointIcon} ${giveaway.pointsPerEntry} ${pointLabel}`;
    document.getElementById('modal-remaining-slots').textContent = `${giveaway.remainingSlots} slots`;

    // Calculate max quantity based on points and slots
    const maxByPoints = Math.floor(availablePoints / giveaway.pointsPerEntry);
    const maxBySlots = giveaway.remainingSlots;
    const maxQuantity = Math.min(CONFIG.maxQuantity, maxByPoints, maxBySlots);

    const qtyInput = document.getElementById('entry-quantity');
    qtyInput.max = maxQuantity;
    qtyInput.value = 1;

    // Update total cost
updateTotalCost();

// Set overlay color based on point type
modal.classList.remove('overlay-gold', 'overlay-silver');

if (giveaway.pointType === 'gold') {
  modal.classList.add('overlay-gold');
} else {
  modal.classList.add('overlay-silver');
}

// Show modal
modal.style.display = 'block';
document.body.style.overflow = 'hidden';

    // Disable redeem button if can't afford even 1 entry
    const redeemBtn = document.getElementById('redeem-btn');
    if (maxQuantity < 1) {
      redeemBtn.disabled = true;
      redeemBtn.textContent = 'Insufficient Points';
    } else {
      redeemBtn.disabled = false;
      redeemBtn.textContent = 'Redeem Now';
    }
  }

  // ============================================
  // QUANTITY CONTROLS
  // ============================================
  
  function adjustQuantity(delta) {
    const qtyInput = document.getElementById('entry-quantity');
    const currentValue = parseInt(qtyInput.value) || 1;
    const newValue = currentValue + delta;
    const min = parseInt(qtyInput.min);
    const max = parseInt(qtyInput.max);

    if (newValue >= min && newValue <= max) {
      qtyInput.value = newValue;
      updateTotalCost();
    }
  }

  function handleQuantityInput(e) {
    const input = e.target;
    let value = parseInt(input.value) || 1;
    const min = parseInt(input.min);
    const max = parseInt(input.max);

    // Clamp value
    if (value < min) value = min;
    if (value > max) value = max;

    input.value = value;
    updateTotalCost();
  }

  function updateTotalCost() {
    const quantity = parseInt(document.getElementById('entry-quantity').value) || 1;
    const giveaway = STATE.currentGiveaway;
    const totalCost = quantity * giveaway.pointsPerEntry;
    const pointLabel = giveaway.pointType === 'gold' ? 'G-Points' : 'S-Points';
    const pointIcon = giveaway.pointType === 'gold' ? '' : '';

    document.getElementById('total-cost-value').textContent = totalCost;
    document.getElementById('total-cost-type').textContent = `${pointIcon} ${pointLabel}`;
  }

  // ============================================
  // REDEEM BUTTON HANDLER
  // ============================================
  
  function handleRedeemClick() {
    const quantity = parseInt(document.getElementById('entry-quantity').value);
    const giveaway = STATE.currentGiveaway;
    const totalCost = quantity * giveaway.pointsPerEntry;
    const pointLabel = giveaway.pointType === 'gold' ? 'G-Points' : 'S-Points';

    // Close quickview
    closeModal('giveaway-quickview-modal');

    // Show confirmation modal
    const confirmationMessage = `
      Are you ready to redeem <strong>${totalCost} ${pointLabel}</strong> for <strong>${quantity} ${quantity === 1 ? 'entry' : 'entries'}</strong> in <strong>${giveaway.giveawayCode}</strong>?
      <br><br>
      <small>Your points will be locked until the giveaway ends.</small>
    `;

    document.getElementById('confirmation-message').innerHTML = confirmationMessage;
    const confirmationModal = document.getElementById('confirmation-modal');

confirmationModal.classList.remove('overlay-gold', 'overlay-silver');

if (giveaway.pointType === 'gold') {
  confirmationModal.classList.add('overlay-gold');
} else {
  confirmationModal.classList.add('overlay-silver');
}
    openModal('confirmation-modal');
  }

  // ============================================
  // CONFIRMATION HANDLER
  // ============================================
  
  function handleConfirmYes() {
    if (STATE.isProcessing) return;

    closeAllModals();
    processRedemption();
  }

  // ============================================
  // AJAX REDEMPTION PROCESSING
  // ============================================
  
  async function processRedemption() {
  STATE.isProcessing = true;

  const quantity = parseInt(document.getElementById('entry-quantity').value);
  const giveaway = STATE.currentGiveaway;
  const customer = STATE.customerData;
  const totalPoints = quantity * giveaway.pointsPerEntry;

  // Show loading state
  showLoadingState();

  // Prepare payload for Mechanic
  const payload = {
    customer_id: customer.customer_id,
    customer_email: customer.customer_email,
    customer_name: customer.customer_name,
    product_id: giveaway.productId,
    giveaway_code: giveaway.giveawayCode,
    prize_title: giveaway.prizeTitle,
    quantity: quantity,
    points_per_entry: giveaway.pointsPerEntry,
    point_type: giveaway.pointType,
    total_points: totalPoints,
    timestamp: new Date().toISOString()
  };

  console.log('Sending redemption request:', payload);

  try {
    // Send to Mechanic webhook
    const response = await fetch(CONFIG.mechanicWebhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    // Mechanic webhooks return 200 if received successfully
    // They don't return JSON, just check status
    if (response.ok || response.status === 200) {
      console.log('✅ Webhook received by Mechanic');
      
      // Generate placeholder tokens for immediate display
      const placeholderTokens = generatePlaceholderTokens(
        quantity, 
        giveaway.bookedSlots, 
        giveaway.giveawayCode
      );
      
      // Show success message
      handleRedemptionSuccess({
        success: true,
        tokens: placeholderTokens,
        message: 'Processing your entry...'
      });
      
      // Wait 3 seconds for Mechanic to process, then reload
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      
    } else {
      throw new Error(`Webhook request failed with status: ${response.status}`);
    }

  } catch (error) {
    console.error('Redemption error:', error);
    handleRedemptionError('Network error. Please check your connection and try again.');
  } finally {
    STATE.isProcessing = false;
    hideLoadingState();
  }
}

// Helper function to generate placeholder tokens for immediate display
function generatePlaceholderTokens(quantity, currentBooked, giveawayCode) {
  const tokens = [];
  for (let i = 1; i <= quantity; i++) {
    const tokenNum = String(currentBooked + i).padStart(3, '0');
    tokens.push(`${giveawayCode}-${tokenNum}`);
  }
  return tokens;
}


  // ============================================
  // SUCCESS/ERROR HANDLERS
  // ============================================
  
  function handleRedemptionSuccess(result) {
    const tokens = result.tokens || [];
    const tokensText = tokens.length > 0 ? tokens.join(', ') : 'Check your email';

    const successMessage = `
      Your entry has been confirmed!
      <br><br>
      <strong>Entry Tokens:</strong><br>
      ${tokensText}
      <br><br>
      <small>A confirmation email has been sent to ${STATE.customerData.customer_email}</small>
    `;

    document.getElementById('success-message').innerHTML = successMessage;
    const successModal = document.getElementById('success-modal');

successModal.classList.remove('overlay-gold', 'overlay-silver');

if (STATE.currentGiveaway.pointType === 'gold') {
  successModal.classList.add('overlay-gold');
} else {
  successModal.classList.add('overlay-silver');
}
    openModal('success-modal');

    // Update UI with new values
    updateUIAfterRedemption(result);
  }

  function handleRedemptionError(errorMessage) {
    document.getElementById('error-message').textContent = errorMessage;

const errorModal = document.getElementById('error-modal');

errorModal.classList.remove('overlay-gold', 'overlay-silver');

if (STATE.currentGiveaway.pointType === 'gold') {
  errorModal.classList.add('overlay-gold');
} else {
  errorModal.classList.add('overlay-silver');
}

openModal('error-modal');
  }

  function handleSuccessClose() {
    closeAllModals();
    // Reload page to show updated slot counts
    window.location.reload();
  }

  // ============================================
  // UI UPDATES
  // ============================================
  
  function updateUIAfterRedemption(result) {
    // Update customer points in sidebar
    if (result.new_available_points !== undefined) {
      const pointType = STATE.currentGiveaway.pointType;
      const balanceElement = document.querySelector(
        `.balance-item--${pointType} .balance-value`
      );
      if (balanceElement) {
        balanceElement.textContent = result.new_available_points;
        balanceElement.dataset[`customer${pointType.charAt(0).toUpperCase() + pointType.slice(1)}Available`] = result.new_available_points;
      }
    }





  







    // Update slot counter on card
    if (result.new_booked_count !== undefined) {
      const card = document.querySelector(`[data-product-id="${STATE.currentGiveaway.productId}"]`);
      if (card) {
        const slotsBadge = card.querySelector('.slots-badge');
        const slotsBooked = card.querySelector('.slots-booked');
        const slotsRemaining = card.querySelector('.slots-remaining');
        
        if (slotsBooked) slotsBooked.textContent = result.new_booked_count;
        if (slotsRemaining) {
          const remaining = STATE.currentGiveaway.totalSlots - result.new_booked_count;
          slotsRemaining.textContent = remaining;
        }

        // Update progress bar
        const progressFill = card.querySelector('.progress-fill');
        if (progressFill) {
          const percent = (result.new_booked_count / STATE.currentGiveaway.totalSlots) * 100;
          progressFill.style.width = `${percent}%`;
        }

        const progressText = card.querySelector('.progress-text');
        if (progressText) {
          progressText.textContent = `${result.new_booked_count} of ${STATE.currentGiveaway.totalSlots} entries filled`;
        }
      }
    }
  }

  // ============================================
  // DATE PICKER & WINNERS
  // ============================================
  
  function initializeDatePicker() {
    const datePicker = document.getElementById('winner-date-picker');
    if (!datePicker) return;

    datePicker.addEventListener('change', handleDateChange);
  }

  function handleDateChange(e) {
    const selectedDate = e.target.value;
    if (!selectedDate) return;

    const completedGiveaways = STATE.customerData.completed_giveaways || [];
    const winnersForDate = completedGiveaways.filter(g => g.winner_date === selectedDate);

    const winnersList = document.getElementById('winners-list');
    
    if (winnersForDate.length === 0) {
      winnersList.innerHTML = '<p class="no-winners-message">No winners announced for this date</p>';
      return;
    }

    // Display winners
    let html = '<div class="winners-items">';
    winnersForDate.forEach(winner => {
      html += `
        <div class="winner-item" data-winner-image="${winner.winner_image}">
          <span class="winner-code">${winner.code}</span>
          <span class="winner-prize">${winner.prize}</span>
        </div>
      `;
    });
    html += '</div>';

    winnersList.innerHTML = html;

    // Attach click handlers to winner items
    document.querySelectorAll('.winner-item').forEach(item => {
      item.addEventListener('click', () => {
        const imageUrl = item.dataset.winnerImage;
        if (imageUrl && imageUrl !== '') {
          showWinnerImage(imageUrl);
        }
      });
    });
  }

  function showWinnerImage(imageUrl) {
    const modal = document.getElementById('winner-modal');
    const img = document.getElementById('winner-image');
    
    img.src = imageUrl;
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  // ============================================
  // MODAL UTILITIES
  // ============================================
  
  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  function closeAllModals() {
    document.querySelectorAll('.giveaway-modal').forEach(modal => {
      modal.style.display = 'none';
    });
    document.body.style.overflow = '';
  }

  // ============================================
  // LOADING STATE
  // ============================================
  
  function showLoadingState() {
    // Create loading overlay
    const overlay = document.createElement('div');
    overlay.id = 'loading-overlay';
    overlay.innerHTML = `
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>Processing your entry...</p>
      </div>
    `;
    document.body.appendChild(overlay);
  }

  function hideLoadingState() {
    const overlay = document.getElementById('loading-overlay');
    if (overlay) {
      overlay.remove();
    }
  }

  // ============================================
  // INITIALIZE ON DOM READY
  // ============================================
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
